// extracted by mini-css-extract-plugin
export var brand = "_1z-9";
export var compact = "_1z-6";
export var extraSmall = "_1z-7";
export var icon = "_1z-0";
export var large = "_1z-4";
export var light = "_1z-1";
export var medium = "_1z-5";
export var outline = "_1z-b";
export var primaryDark = "_1z-a";
export var primaryLight = "_1z-8";
export var primaryModern = "_1z-c";
export var success = "_1z-2";
export var successSolid = "_1z-3";